import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/logo.png';
const _hoisted_1 = { class: "hero is-small is-primary" };
const _hoisted_2 = { class: "hero-body is-flex is-flex-direction-row" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "is-flex is-align-items-center" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        class: "image is-64x64",
        src: _imports_0
    })
], -1);
const _hoisted_4 = { class: "is-flex is-align-items-center px-3" };
const _hoisted_5 = { class: "title allerta-stencil-regular is-uppercase" };
const _hoisted_6 = { class: "subtitle allerta-stencil-regular" };
const _hoisted_7 = { class: "section px-3" };
const _hoisted_8 = { class: "container" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("div", { class: "is-flex-grow-1" }, null, -1);
const _hoisted_10 = { class: "footer" };
const _hoisted_11 = { class: "level" };
const _hoisted_12 = { class: "level-item" };
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = { class: "level-right" };
const _hoisted_15 = { class: "level-item" };
import { marked } from "marked";
import { PublicStore } from "./lib/store/public";
import LoginButton from "./components/LoginButton.vue";
import MainView from "./components/view/MainView.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const store = PublicStore();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("header", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _hoisted_3,
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", null, [
                                _createElementVNode("h1", _hoisted_5, _toDisplayString(_unref(store).website_config.title), 1),
                                _createElementVNode("h2", _hoisted_6, _toDisplayString(_unref(store).website_config.subtitle), 1)
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("main", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createVNode(MainView)
                    ])
                ]),
                _hoisted_9,
                _createElementVNode("footer", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("p", {
                                innerHTML: _unref(marked).parse(_unref(store).website_config.footer)
                            }, null, 8, _hoisted_13)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                                _createVNode(LoginButton, { class: "is-small is-info is-outlined" })
                            ])
                        ])
                    ])
                ])
            ], 64));
        };
    }
});
